<template>
  <div class="row">
    <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4" v-for="option in options">
      <label :key="option.value" :class="['custom-checkbox', { 'checked': isChecked(option.value) }]">
        <input
            type="checkbox"
            :value="option.value"
            :checked="isChecked(option.value)"
            @change="handleChange($event, option.value)"
        />
        <span class="checkmark"></span>
        {{ option.name }}
      </label>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'CustomCheckboxGroup',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    isChecked(optionValue) {
      return this.value.includes(optionValue);
    },
    handleChange(event, value) {
      let newValue;
      if (this.multiple) {
        if (event.target.checked) {
          newValue = [...this.value, value];
        } else {
          newValue = this.value.filter((v) => v !== value);
        }
      } else {
        newValue = event.target.checked ? [value] : [];
      }
      this.$emit('input', newValue);
    },
  }
};
</script>

<style scoped>
.custom-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 5px;
  color: var(--primary-color-new);
  font-size: 14px;
  font-weight: 400;
}
.custom-checkbox input {
  display: none;
}
.custom-checkbox .checkmark {
  width: 20px;
  height: 20px;
  background-color: transparent;
  border: 2px solid var(--gray-color-new);
  border-radius: 3px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: middle;
  position: relative;
}
.custom-checkbox.checked .checkmark {
  background-color: var(--text-primary-color-new-transparent);
  border-color: var(--primary-color-new);
}
.custom-checkbox .checkmark::after {
  content: '';
  position: absolute;
  left: 5px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  opacity: 0;
}
.custom-checkbox.checked .checkmark::after {
  opacity: 1;
}
</style>
